// extracted by mini-css-extract-plugin
export default {"homepageView":"homepage_homepageView__YZehB","homepage_view":"homepage_homepage_view__EPzsK","App-logo-spin":"homepage_App-logo-spin__JBLXP"};